import { Backdrop, CircularProgress } from "@mui/material";

import { getTimeMeInstance } from "./timeMe";
import { get, post } from "../api/";

export const getPageContent = (body, status, error) => {
    let content;
    const loading =
        status === "loading" ? (
            <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        ) : (
            ""
        );

    return status === "failed" ? (
        <p>Error : {error}</p>
    ) : (
        <>
            {body}
            {loading}
        </>
    );
};

export const uniqueString = (length) => {
    let result = "";
    let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

export const getTimeMe = () => {
    return getTimeMeInstance();
};

export const setLocalStorage = (key, data, ttl) => {
    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        value: data,
        expiry: now.getTime() + (ttl ? ttl : 2 * 60 * 60 * 1000),
    };
    try {
        localStorage.setItem(key, JSON.stringify(item));
    } catch (error) {
        localStorage.clear();
        setTimeout(() => {
            try {
                localStorage.setItem(key, JSON.stringify(item));
            } catch (error) {
                console.log(error);
            }
        }, 10 * 1000);
    }
};

export const getLocalStorage = (key) => {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
};

export const convertNumberToShort = (number, initials) => {
    if (number) {
        if (number < 1000) {
            return initials + number.toString();
        } else if (number < 1000000) {
            return initials + (number / 1000).toFixed(1) + "K";
        } else if (number < 1000000000) {
            return initials + (number / 1000000).toFixed(1) + "M";
        } else {
            return initials + (number / 1000000000).toFixed(1) + "B";
        }
    }
    return initials + "0";
};

export const formatDateTimeRange = (startDateTime, endDateTime) => {
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const startDay = daysOfWeek[startDateTime.getDay()];
    const startHour = startDateTime.getHours() % 12 === 0 ? 12 : startDateTime.getHours() % 12;
    const startPeriod = startDateTime.getHours() >= 12 ? "PM" : "AM";

    const endDay = daysOfWeek[endDateTime.getDay()];
    const endHour = endDateTime.getHours() % 12 === 0 ? 12 : endDateTime.getHours() % 12;
    const endPeriod = endDateTime.getHours() >= 12 ? "PM" : "AM";
    if (startDay === endDay) {
        const formattedStartTime = `${startDay}, ${startHour}${startPeriod}`;
        const formattedEndTime = `${endHour}${endPeriod}`;

        return `${formattedStartTime} To ${formattedEndTime}`;
    } else {
        const formattedStartTime = `${startDay}, ${startHour}${startPeriod}`;
        const formattedEndTime = `${endDay}, ${endHour}${endPeriod}`;

        return `${formattedStartTime} To ${formattedEndTime}`;
    }
};

export const updateCurrentScreen = (userDetails, currentScreen, currentTab) => {
    if (userDetails.applicant) {
        userDetails.applicant.currentScreen = currentScreen;
        userDetails.applicant.currentTab = currentTab;
        post("applicant/updateCurrentScreen", {
            userId: userDetails.applicant.id,
            currentScreen: currentScreen,
            currentTab: currentTab,
        });
    }

    return userDetails;
};

export const updateApplicant = (applicant, currentScreen) => {
    post("applicant/updateApplicant", {
        applicant: applicant,
        currentScreen: currentScreen,
    });
};

export const continueFromStart = (applicant) => {
    post("applicant/continueFromStart", {
        userId: applicant.id,
    });
};

export const getAllUrlParams = (url) => {
    let queryString = url ? url.split("?")[1] : window.location.search.slice(1);

    let obj = {};

    if (queryString) {
        queryString = queryString.split("#")[0];

        let arr = queryString.split("&");

        for (let i = 0; i < arr.length; i++) {
            let a = arr[i].split("=");

            let paramName = a[0];
            let paramValue = typeof a[1] === "undefined" ? true : a[1];

            if (paramName.match(/\[(\d+)?\]$/)) {
                let key = paramName.replace(/\[(\d+)?\]/, "");
                if (!obj[key]) obj[key] = [];

                if (paramName.match(/\[\d+\]$/)) {
                    let index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    obj[key].push(paramValue);
                }
            } else {
                if (!obj[paramName]) {
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === "string") {
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
};
